import { BaseBus } from "./BaseBus";
import { v_InventoryBus } from "./v_InventoryBus";
import { CommonFunctions } from "../static/common-functions";
import { QILineItemBus } from "./QILineItem";
import { DateFunctions } from "../static/date-functions";

export class v_InvoiceLineItemBus extends QILineItemBus {
    constructor(busObj: v_InvoiceLineItemBus = null) {
        super(busObj);
        this.originalQuantity = this.quantity;
        this.sageDt = DateFunctions.getDate(this.sageDt);
        this.sageCostDt = DateFunctions.getDate(this.sageCostDt);
        this.isDraged = false;
    }
    get usesOrderValue(): boolean {
        return true;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    CID(): any {
        return this.invoiceLineId;
    }
    setId(id: any) {
        this.invoiceLineId = id;
    }
    setParentId(id: any) {
        this.invoiceId = id;
    }
    changeInventoryItem(data: v_InventoryBus) {
        super.changeInventoryItem(data);
        this.invoiceLineDesc = data.inventoryDesc;
    }
    setInventoryLine(data: QILineItemBus) {
        super.setInventoryLine(data);
        this.invoiceLineDesc = data.lineDesc;
    }
    setValuesToNull() {
        super.setValuesToNull();
        this.invoiceLineId = null;
        this.invoiceLineDesc = null;
        this.sageDt = null;
        this.sageCostDt = null;
        this.invoiceId = null;
        this.dispatchId = null;
        this.invoiceNumber = null;
        this.resource = null;
        this.warehouse = null;
        this.billingTypeName = null;
        this.dispatchNumber = null;
        this.warehouseName = null
        this.changeCodeId = null;
        this.changeCodeDesc = null;
       
    }
    invoiceLineId: any;
    invoiceLineDesc: string;
    sageDt: Date;
    sageCostDt: Date;
    invoiceId: string;
    dispatchId: string;
    invoiceNumber: string;
    resource: string;
    warehouse: string;
    billingTypeName: string;
    dispatchNumber: string;
    isDraged: boolean;
    inventoryFromCode: string;
    excessInventoryLocationToId: any;
    originalQuantity: number;
    changeCodeId: any;
    changeCodeDesc: string;
    selected: boolean;
    warehouseName: string;
    splitQuantity: number; //also CreditMemo Qty
    corr1Qty: number;
    corr2Qty: number;
    origin: string;
    totalCostCorr1: number;
    totalCostCorr2: number;
    amountCredit: number;
    amountCorr1: number;
    amountCorr2: number;
    corr1IsBillable: boolean;
    corr2IsBillable: boolean;
    relatedJobTypeId: string;
    orderDetailId: string;
}
